import { render, staticRenderFns } from "./exportExcelFacture.vue?vue&type=template&id=2f9be660&scoped=true&"
import script from "./exportExcelFacture.vue?vue&type=script&lang=js&"
export * from "./exportExcelFacture.vue?vue&type=script&lang=js&"
import style0 from "./exportExcelFacture.vue?vue&type=style&index=0&id=2f9be660&scoped=true&lang=scss&"
import style1 from "./exportExcelFacture.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f9be660",
  null
  
)

export default component.exports